import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CompanyPortfolio from './components/CompanyPortfolio';
import GupshupWebsite from './components/GupshupWebsite';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import DakhlaApp from './components/DakhlaApp';
import ContactUs from './components/ContactUs';
import ChildSafety from './components/ChildSafety';
import TellMeApp from './components/TellMeApp';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CompanyPortfolio />} />
        <Route path="/gupshup-app" element={<GupshupWebsite />} />
        <Route path="/dakhla-app" element={<DakhlaApp />} />
        <Route path="/findpartner-app" element={<DakhlaApp />} />
        <Route path="/tellme-app" element={<TellMeApp />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
    </Router>
  );
}

export default App;

